var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import { Row, Col } from "react-bootstrap";
import { FormattedMessage, FormattedCurrency } from "@irati/utils/lang";
import { Label1 } from "@irati/ui/src/Labels";
var StyledLabel = styled(Label1)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 30px;\n"], ["\n  font-size: 30px;\n"])));
var Total = function (_a) {
    var total = _a.total, _b = _a.paid, paid = _b === void 0 ? false : _b, currency = _a.currency;
    return (React.createElement(Row, null,
        React.createElement(Col, { xs: 12 },
            React.createElement("strong", null,
                React.createElement(FormattedMessage, { id: paid ? "perks.components.orderSummary.total.paid" : "perks.components.orderSummary.total.toPay" }))),
        React.createElement(Col, { xs: 12 },
            React.createElement("div", { className: "pull-right" },
                React.createElement(StyledLabel, { bold: true },
                    React.createElement(FormattedCurrency, { currency: currency, value: total }))))));
};
export default Total;
var templateObject_1;
